// An accumulation of these can slow down the router.
// This file should be used very sparingly and under special circumstance.
// Do not make any guarantees that these re-directs will last longer than a year.

// This template is not used and is just to help generate new ones for the projectRedirects array
const template = {
  removeAfter: "Removal Date Text",
  path: "/projects/old-project-url/:pathMatch(.*)*",
  redirect: (to) => {
    return `/projects/new-project-url/${to.params.pathMatch || ""}`;
  },
};

const projectRedirects = [
  {
    removeAfter: "8/12/2026",
    path: "/projects/tic-tank-observations-fobes-lite/:pathMatch(.*)*",
    redirect: (to) => {
      return `/projects/tic-tank-observations/${to.params.pathMatch || ""}`;
    },
  },
];

export default projectRedirects;
